// extracted by mini-css-extract-plugin
export default {"vertical-dots":"CustomTimeline_vertical-dots__IqesJ","icon":"CustomTimeline_icon__B4ibD","salesforce-icon":"CustomTimeline_salesforce-icon__GnkYD"};